import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
          <div className="max-w-md w-full text-center" data-testid="error-boundary">
            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-red-400 text-2xl">!</span>
            </div>
            <h2 className="text-xl text-white mb-3" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Une erreur est survenue
            </h2>
            <p className="text-white/50 text-sm mb-6">
              Veuillez rafraîchir la page pour continuer.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-[#C5A059] text-black px-6 py-3 text-sm font-medium hover:bg-[#D4AF63] transition-colors"
              data-testid="error-reload-btn"
            >
              Rafraîchir la page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
